import { NgClass, NgForOf, NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common';
import { AfterViewInit, Component } from '@angular/core';
import { Router } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ACTIVE_MENUS_YOUNG } from '@menus/active-menus-young';
import { InstitutionStatus } from '@model/client/institution-status.model';
import { ProgramEnum } from '@model/enumerations/program-enum.model';
import { Account } from '@core/auth/account.model';
import { AccountService } from '@core/auth/account.service';
import { PersonService } from '@core/user/person.service';
import { EventManager } from '@core/util/event-manager.service';
import { InstitutionService } from '@backoffice/institution/institution.service';
import { StorageService } from '@flowinn/components/filter/storage.service';
import { IMenuItem, MenuProfile, MenuType } from '@flowinn/components/layout/sidebar/menu-item';
import { IInstitutionClient, InstitutionClient } from '@model/client/institution-client.model';
import { IPersonInstitution } from '@model/client/person-institution.model';
import { IPersonYoung } from '@model/client/person-young.model';
import { Institution } from '@model/institution.model';
import { TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { BreadcrumbService } from 'xng-breadcrumb';

@Component({
  selector: 'jhi-home-young',
  templateUrl: './home-young.component.html',
  imports: [NgClass, NgSwitch, FontAwesomeModule, NgIf, NgForOf, NgSwitchCase, TranslateModule, NgSwitchDefault],
  standalone: true,
})
export class HomeYoungComponent implements AfterViewInit {
  account?: Account | null;
  personInstitutions: IPersonInstitution[] = [];
  person?: IPersonYoung;
  institution?: IInstitutionClient;
  eventSubscriber?: Subscription;

  ProgramEnum = ProgramEnum;
  MenuType = MenuType;
  MenuProfile = MenuProfile;
  menus: IMenuItem[] = [];

  constructor(
    private router: Router,
    private accountService: AccountService,
    private storageService: StorageService,
    protected personService: PersonService,
    protected eventManager: EventManager,
    protected breadcrumbService: BreadcrumbService,
    protected institutionService: InstitutionService
  ) {
    this.breadcrumbService.set('@homeYoung', 'Área Pessoal');
  }

  trackId(index: number, item: any): void {
    return item.id;
  }

  hasStorageInstitution(): boolean {
    if (this.account) {
      const institution = this.storageService.getStorageInstitution(this.account.id);
      return institution !== undefined && institution.id !== undefined;
    }
    return false;
  }

  ngAfterViewInit(): void {
    this.accountService.identity().subscribe(account => {
      this.account = account;
      if (this.account != null) {
        const accountId = this.account.id;
        this.eventSubscriber = this.eventManager.subscribe(
          'flw-institution',
          () => (this.institution = this.storageService.getStorageInstitution(accountId))
        );
        this.person = this.accountService.getPerson();
        this.personInstitutions = this.accountService.getInstitutions();
        this.institution = this.storageService.getStorageInstitution(accountId);
      }
      this.menus = ACTIVE_MENUS_YOUNG;
    });
  }

  previousState(): void {
    window.history.back();
  }

  selectInstitution(institutionClient?: InstitutionClient): void {
    if (this.account != null) {
      if (institutionClient) {
        this.getByExternalId(institutionClient);
        this.storageService.setStorageInstitution(this.account.id, institutionClient);
      } else {
        this.storageService.clearStorageInstitution(this.account.id);
      }
    }
  }

  getByExternalId(institutionClient: IInstitutionClient): void {
    this.institutionService.query({ 'externalId.equals': institutionClient.id }).subscribe(res => {
      if (res.body && res.body.length > 0) {
        const institution = res.body[0];
        institution.vatNumber = institutionClient.corporateTaxpayerNumber;
      } else {
        this.getByVatNumber(institutionClient);
      }
    });
  }

  getByVatNumber(institutionClient: IInstitutionClient): void {
    this.institutionService.query({ 'vatNumber.equals': institutionClient.corporateTaxpayerNumber }).subscribe(res => {
      if (res.body && res.body.length > 0) {
        const institution = res.body[0];
        institution.externalId = institutionClient.id + '';
      } else {
        const institution = new Institution();
        institution.externalId = institutionClient.id + '';
        institution.vatNumber = institutionClient.corporateTaxpayerNumber;
      }
    });
  }

  getMenuProgram(menu: IMenuItem): ProgramEnum | null {
    if (menu.title) {
      if (menu.title.includes('AGORA_NOS')) {
        return ProgramEnum.AGORA_NOS;
      }
      if (menu.title.includes('NAVEGAS')) {
        return ProgramEnum.NAVEGAS;
      }
      if (menu.title.includes('SOUDIGITAL')) {
        return ProgramEnum.SOUDIGITAL;
      }
      if (menu.title.includes('CTI')) {
        return ProgramEnum.CTI;
      }
      if (menu.title.includes('CUIDA_TE2')) {
        return ProgramEnum.CUIDA_TE2;
      }
      if (menu.title.includes('CUIDA_TE')) {
        return ProgramEnum.CUIDA_TE;
      }
      if (menu.title.includes('EQUALITY')) {
        return ProgramEnum.EQUALITY;
      }
      if (menu.title.includes('EJA')) {
        return ProgramEnum.EJA;
      }
      if (menu.title.includes('EUROSCOLA')) {
        return ProgramEnum.EUROSCOLA;
      }
      if (menu.title.includes('FERIAS')) {
        return ProgramEnum.FERIAS;
      }
      if (menu.title.includes('FLORESTAS')) {
        return ProgramEnum.FLORESTAS;
      }
      if (menu.title.includes('GERACAOZ')) {
        return ProgramEnum.GERACAOZ;
      }
      if (menu.title.includes('AFIRMATE')) {
        return ProgramEnum.AFIRMATE;
      }
      if (menu.title.includes('EMPREENDEJA')) {
        return ProgramEnum.EMPREENDEJA;
      }
      if (menu.title.includes('OTL')) {
        return ProgramEnum.OTL;
      }
      if (menu.title.includes('PASSE_JOVEM')) {
        return ProgramEnum.PASSE_JOVEM;
      }
      if (menu.title.includes('NAMORAR')) {
        return ProgramEnum.NAMORAR;
      }
      if (menu.title.includes('SETENTAJA')) {
        return ProgramEnum.SETENTAJA;
      }
      if (menu.title.includes('WORKCAMP_REGISTRATION')) {
        return ProgramEnum.WORKCAMP_REGISTRATION;
      }
    }
    return null;
  }

  goTo(path?: string): void {
    if (path) {
      // noinspection JSIgnoredPromiseFromCall
      this.router.navigate([path]);
    }
  }

  protected readonly InstitutionStatus = InstitutionStatus;
}
